import { render, staticRenderFns } from "./ContainerTitle.vue?vue&type=template&id=58a4f008"
import script from "./ContainerTitle.vue?vue&type=script&lang=js"
export * from "./ContainerTitle.vue?vue&type=script&lang=js"
import style0 from "./ContainerTitle.vue?vue&type=style&index=0&id=58a4f008&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports